module.exports = __webpack_public_path__ + "static/media/yeti.4b0c3988.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/yeti.png
// module id = 35
// module chunks = 0